import { SelectChangeEvent, SelectProps } from '@mui/material/Select'
import React, { useEffect, useState } from 'react'

import { styled } from '../../theme'
import { COLORS, THEME_CONST } from '../../theme'
import { findDuplicates, MsdkStyledComponent, OptionItem } from '../../utils'
import { Checkbox } from '../Checkbox'
import { MenuItem } from '../Menu'
import { Typography } from '../Typography'
import { BaseSelect } from './BaseSelect'

const StyledSelect: MsdkStyledComponent<SelectProps & any> = styled(BaseSelect)`
  border-radius: ${THEME_CONST.inputBorderRadius}px;
  width: 100%;
`

const StyledMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  gap: 8px;
`
const StyledMenuItemAll = styled(MenuItem)`
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid ${COLORS.divider};
`

type Props = {
  label: string
  options: OptionItem[]
  value: OptionItem[]
  onChange: (value: string[]) => void
  disabled?: boolean
  allLabel?: string
}

export function SelectMultiple({ label, onChange, options, value, disabled, allLabel }: Props) {
  function handleChange(event: SelectChangeEvent<typeof value>) {
    console.log(event.target.value)
    const val = event.target.value
    console.log('value: ', value)
    console.log('val: ', val)
    if (val[val.length - 1] === 'all') {
      handleAllCheck()
      return
    }
    let toSend = typeof val === 'string' ? val.split(',') : (val as any[]).map((v) => (v.value ? v.value : v))
    /*
     * the MUI component returns a list of values (where the already selected one are an instance of `OptionItem`
     * and the new one is a plain string) in wich the deselected value by the user
     * is added as a duplicate item at the bottom of the array
     * to handle this corner case i check for duplicate items
     * and then remove them as they signify a deselected value...
     */
    const duplicates = findDuplicates(toSend)
    toSend = toSend.filter((i) => !duplicates.includes(i))
    onChange(toSend)
  }

  function handleAllCheck() {
    const newCheckedItems = allChecked ? [] : options.map((e) => e.value)
    console.log(newCheckedItems)

    // setCheckedItems(newCheckedItems)
    onChange(newCheckedItems)
    setAllChecked(!allChecked)
  }

  const [allChecked, setAllChecked] = useState<boolean>(false)

  function onRender() {
    if (allChecked) return options.map((v) => v.label).join(', ')
    if (value && Array.isArray(value)) return value.map((v) => v.label).join(', ')
    return ''
  }

  function isChecked(e: OptionItem) {
    const r = value.findIndex((el: OptionItem) => el.value === e.value)
    return r !== -1
  }

  function isAllChecked() {
    return options.length > 0 && value.length === options.length
  }

  useEffect(() => {
    setAllChecked(options.length > 0 && value.length === options.length)
  }, [value])

  return (
    <StyledSelect
      data-test-id="select-multiple"
      label={label}
      value={value}
      multiple
      onChange={handleChange}
      renderValue={onRender}
      disabled={disabled}
    >
      {/* <Wrapper> */}
      {typeof allLabel !== 'undefined' && (
        <StyledMenuItemAll key={crypto.randomUUID()} value="all">
          <Checkbox
            disabled={disabled}
            checked={isAllChecked()}
            // onChange={handleAllCheck}
            indeterminate={value.length > 0 && value.length < options.length}
            data-test-id="select-multiple-all"
          />
          <Typography variant="body1">{allLabel}</Typography>
        </StyledMenuItemAll>
      )}
      {/* <Divider /> */}
      {options.map((e) => (
        <StyledMenuItem key={crypto.randomUUID()} value={e.value}>
          <Checkbox disabled={disabled} checked={isChecked(e)} data-test-id="select-multiple-item" />
          <Typography variant="body1">{e.label}</Typography>
        </StyledMenuItem>
      ))}
      {/* </Wrapper> */}
    </StyledSelect>
  )
}
